/**
 * Serial numbers (friendly IDs / idf) of the "Swiss" clock batch.
 *
 * These match the lowercase `idf` field on machine documents in Firestore
 * (e.g. "afraid-moth-34"). They are stored here exactly as provided
 * (uppercase) and normalized to lowercase via {@link SWISS_CLOCK_IDFS}.
 */
const SWISS_CLOCK_SERIALS = [
  "AFRAID-MOTH-34",
  "ANCIENT-HUSKY-6",
  "ANCIENT-RAT-64",
  "BAD-PENGUIN-50",
  "BLACK-DRAGON-99",
  "BREEZY-COW-43",
  "BREEZY-EEL-84",
  "BREEZY-EMU-72",
  "BREEZY-FIREFOX-3",
  "BRIGHT-BULLFROG-79",
  "BRIGHT-FIREFOX-11",
  "BRIGHT-LIGER-18",
  "BRIGHT-NEWT-23",
  "BROWN-MOLE-87",
  "CALM-CRAB-14",
  "CLEVER-BIRD-80",
  "CURVY-TURTLE-26",
  "DANGEROUS-EARWIG-89",
  "DANGEROUS-TURKEY-87",
  "DRY-MOUSE-81",
  "FAT-PANTHER-22",
  "FRIENDLY-PANTHER-54",
  "FRIENDLY-SKUNK-46",
  "FUNNY-DUCK-33",
  "GOOD-MOTH-56",
  "GOOD-OWL-56",
  "GRUMPY-DINGO-44",
  "GRUMPY-FROG-43",
  "GRUMPY-PANDA-35",
  "HAPPY-DODO-63",
  "HAPPY-MAYFLY-34",
  "HAPPY-TREEFROG-66",
  "HARD-CHICKEN-29",
  "HARD-DEER-39",
  "HELPLESS-GECKO-40",
  "HORRIBLE-HOUND-45",
  "JOLLY-DOG-82",
  "KIND-MOTH-62",
  "LITTLE-DOLPHIN-25",
  "LITTLE-EAGLE-4",
  "LITTLE-INSECT-14",
  "LITTLE-KANGAROO-100",
  "MIGHTY-SHEEP-90",
  "NEAT-WOLVERINE-33",
  "ODD-PENGUIN-100",
  "OLD-ROBIN-38",
  "ORDINARY-SLOTH-55",
  "PINK-FIREANT-86",
  "PINK-PANTHER-90",
  "PLASTIC-PUG-23",
  "POPULAR-GECKO-20",
  "PRETTY-BULLDOG-34",
  "PRETTY-MOLE-71",
  "PROUD-EMU-86",
  "PROUD-PANTHER-38",
  "QUICK-PANTHER-88",
  "RUDE-APE-69",
  "RUDE-PIG-41",
  "SELFISH-BOBCAT-47",
  "SELFISH-PARROT-3",
  "SELFISH-TURKEY-71",
  "SHAGGY-LADYBUG-73",
  "SHARP-TREEFROG-100",
  "SILLY-SEAHORSE-81",
  "SLIMY-IMPALA-27",
  "SMOOTH-BABOON-58",
  "SOFT-BEAR-27",
  "SOUR-FISH-46",
  "TALL-GOAT-39",
  "TASTY-HOUND-3",
  "TERRIBLE-SEAHORSE-57",
  "TIDY-SEAHORSE-83",
  "TRICKY-FIREFOX-41",
  "UGLY-FIREFOX-39",
  "UGLY-OCTOPUS-56",
  "WEAK-WOMBAT-84",
  "WHITE-CHEETAH-22",
  "WITTY-SHEEP-94",
  "WONDERFUL-SEAHORSE-19",
  "YOUNG-PUMA-52",
  "AFRAID-HOUND-13",
  "AFRAID-TERMITE-40",
  "ANCIENT-DOLPHIN-51",
  "ANCIENT-FIREANT-80",
  "ANCIENT-RAT-92",
  "ANGRY-RAT-36",
  "BITTER-FROG-85",
  "BLUE-ROBIN-92",
  "BRAVE-DRAGON-83",
  "BREEZY-BABOON-16",
  "BREEZY-BULLDOG-56",
  "BRIGHT-BABOON-56",
  "CALM-FOX-2",
  "CHATTY-CHIPMUNK-64",
  "CHATTY-PARROT-31",
  "CHATTY-TIGER-65",
  "CHILLY-COBRA-45",
  "CHILLY-DUCK-49",
  "CLEVER-DOLPHIN-91",
  "CLEVER-TURKEY-83",
  "COWARDLY-EEL-6",
  "COWARDLY-PUMA-6",
  "DANGEROUS-MOOSE-29",
  "DULL-MONKEY-66",
  "DULL-SNAIL-94",
  "FAT-LIGER-10",
  "FLUFFY-SEAHORSE-61",
  "FOOLISH-CHEETAH-10",
  "FOOLISH-DODO-29",
  "FOOLISH-DUCK-5",
  "FOOLISH-LIGER-42",
  "FOOLISH-SKUNK-52",
  "FRIENDLY-DOG-2",
  "FRIENDLY-SQUID-94",
  "FRIENDLY-TURKEY-5",
  "FRIENDLY-VAMPIREBAT-95",
  "FUNNY-BADGER-91",
  "GREAT-RAT-56",
  "GREAT-SHEEP-38",
  "GREAT-SQUID-16",
  "GREEN-CRAB-66",
  "GRUMPY-BAT-88",
  "GRUMPY-KANGAROO-78",
  "GRUMPY-SLOTH-39",
  "GRUMPY-WOLVERINE-99",
  "HAPPY-FLY-25",
  "HAPPY-PARROT-0",
  "HARD-JELLYFISH-95",
  "HONEST-PARROT-13",
  "HOT-DEER-61",
  "HOT-DEER-93",
  "HUNGRY-EARWIG-79",
  "ITCHY-MOTH-66",
  "KIND-ELEPHANT-21",
  "KIND-MOTH-70",
  "KIND-QUAIL-74",
  "KIND-TERMITE-34",
  "LIGHT-BULLFROG-25",
  "LITTLE-MAYFLY-76",
  "LOUD-BABOON-82",
  "LOVELY-DUCK-19",
  "LUCKY-DINGO-62",
  "LUCKY-GRASSHOPPER-37",
  "LUCKY-YAK-45",
  "MEAN-SLOTH-41",
  "MIGHTY-BABOON-28",
  "MIGHTY-EEL-6",
  "MIGHTY-FOX-82",
  "MIGHTY-HUSKY-26",
  "MODERN-GECKO-56",
  "MOODY-DOG-62",
  "NASTY-COBRA-55",
  "NASTY-JELLYFISH-89",
  "NEAT-MOOSE-77",
  "NEAT-MOTH-32",
  "NERVOUS-MONKEY-52",
  "NERVOUS-WOLVERINE-9",
  "NEW-OCTOPUS-86",
  "NICE-FOX-38",
  "OLD-PARROT-79",
  "PINK-COW-27",
  "PLASTIC-PANTHER-92",
  "POLITE-BEAR-53",
  "POLITE-SHEEP-56",
  "PRETTY-SHRIMP-89",
  "PROUD-PANDA-15",
  "PROUD-PANTHER-80",
  "PURPLE-DEER-95",
  "PURPLE-PANTHER-64",
  "PURPLE-STARFISH-25",
  "QUIET-CHIPMUNK-52",
  "QUIET-FIREANT-20",
  "QUIET-STARFISH-93",
  "RARE-BULLFROG-11",
  "RED-LADYBUG-41",
  "ROTTEN-DOLPHIN-29",
  "ROTTEN-GOOSE-86",
  "SELFISH-DUCK-7",
  "SELFISH-EAGLE-96",
  "SELFISH-FIREANT-32",
  "SELFISH-GECKO-62",
  "SHAGGY-ELEPHANT-99",
  "SILENT-PUMA-56",
  "SILLY-DUCK-81",
  "SLIMY-INSECT-10",
  "SLIPPERY-CRAB-20",
  "SMART-APE-91",
  "SMOOTH-VAMPIREBAT-35",
  "SOUR-MONKEY-74",
  "SPICY-STINGRAY-46",
  "TALL-COBRA-67",
  "TAME-EARWIG-13",
  "TASTY-APE-47",
  "TASTY-DONKEY-56",
  "TASTY-FIREANT-50",
  "TERRIBLE-PUMA-78",
  "TERRIBLE-WARTHOG-75",
  "TIDY-APE-29",
  "TIDY-KANGAROO-20",
  "TIDY-YAK-49",
  "TRICKY-PUG-41",
  "UGLY-COW-95",
  "WARM-FROG-91",
  "WEAK-NEWT-3",
  "WEAK-ROBIN-58",
  "WEAK-STARFISH-77",
  "WHITE-DRAGONFLY-50",
  "WHITE-PIG-47",
  "WHITE-SKUNK-48",
  "WITTY-LIZARD-15",
  "AFRAID-MOOSE-65",
  "ANGRY-SHEEP-16",
  "BREEZY-WOMBAT-92",
  "BRIGHT-TURTLE-54",
  "CALM-APE-75",
  "CALM-PUMA-34",
  "CHATTY-SHRIMP-83",
  "CLEVER-NEWT-81",
  "CLEVER-STARFISH-75",
  "COWARDLY-SKUNK-14",
  "EVIL-PANTHER-16",
  "FRESH-TERMITE-88",
  "GREAT-PANTHER-88",
  "HAPPY-DONKEY-70",
  "HARD-MONKEY-10",
  "HOT-HOUND-5",
  "ITCHY-HUSKY-64",
  "ITCHY-YAK-39",
  "JOLLY-RAT-48",
  "LITTLE-FIREFOX-41",
  "LOUD-DOLPHIN-69",
  "MEAN-APE-79",
  "NICE-GOOSE-16",
  "OLD-BEAR-93",
  "ORANGE-MOOSE-11",
  "PERFECT-WASP-90",
  "PINK-BABOON-20",
  "POLITE-FISH-54",
  "QUIET-WOMBAT-12",
  "RARE-FIREFOX-51",
  "SILLY-WALRUS-50",
  "SLIMY-YAK-29",
  "SOFT-NEWT-67",
  "SPLENDID-FOX-50",
  "STRONG-FIREANT-44",
  "THIN-EEL-84",
  "TOUGH-DOG-74",
  "WEAK-BULLDOG-80",
  "WONDERFUL-TIGER-35",
  "YELLOW-BULLDOG-36",
];

/**
 * Swiss clock serials normalized to the lowercase `idf` form stored on
 * machine documents, de-duplicated. Use this to query Firestore.
 */
export const SWISS_CLOCK_IDFS = Array.from(
  new Set(SWISS_CLOCK_SERIALS.map((s) => s.trim().toLowerCase())),
);

export default SWISS_CLOCK_SERIALS;
